import React from 'react';
import { Typography } from '@material-ui/core';

const LienAvecVerification = ({ url, label, fallbackUrl, classes, footerLink = 'footerLink', style, target = '' }) => (
    <Typography className={`${classes?.alignTextRight || ''}`} variant="caption" style={style}>
        {url && (
            url.startsWith('http') || url.startsWith('<p>http') ? ( // url externe 
                <a href={url.replace(/<\/?p>/g, '')} target="_blank" rel="noopener noreferrer" className={`${classes?.linkStyle || ''} ${footerLink}`}>
                    {label}
                </a>
            ) : url.trim() !== '' ? (
                <a href={fallbackUrl} className={`${classes?.linkStyle || ''} ${footerLink}` } target={target}>
                    {label}
                </a>
            ) : null
        )}
    </Typography>
);

export default LienAvecVerification;
